class SnackbarService {

    constructor($timeout, $sce) {
        'ngInject';
        
        this.$timeout = $timeout;
        this.$sce = $sce;
        this.messages = [];
    }

    add(content, type = 'success', dismissable = true, timeout = null, customCallback = null) {
        let newMessage = {
            type,
            content: this.$sce.trustAsHtml(content),
            isDismissable: dismissable,
            timeout: null,
            callback: (message, isUserClick) => {
                if (message.timeout) this.$timeout.cancel(message.timeout);

                this.messages = this.messages.filter(m => m != message);

                if (isUserClick && customCallback && typeof customCallback == 'function') {
                    customCallback();
                }
            }
        };

        if (timeout) {
            newMessage.timeout = this.$timeout(() => {
                newMessage.callback(newMessage, false);
            }, timeout);
        }

        this.messages.push(newMessage);
    }

    clear() {

    }
}

export default SnackbarService;